import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import { ActivatedRoute, Router } from '@angular/router';

import momentJalaali from 'moment-jalaali';

import moment from 'moment-jalaali';

declare let $: any;

@Component({

  selector: 'app-temp-access-admin',

  templateUrl: './temp-access-admin.component.html',

  styleUrls: ['./temp-access-admin.component.css']

})

export class TempAccessAdminComponent implements OnInit {

  list_Result: any = [];

  list_Search: any = [];

  loading = false;
  hasError = false;
  searchText = '';
  currentPage = 1;
  pageSize = 20;
  pagedRows: any[] = [];

  bEditMode: boolean = false;

  mdlTempAccess: FormGroup = this.FormBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    iTemporaryAccess: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strSTime: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strETime: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strPassword: new FormControl('', Validators.required),

  })

  constructor(

    private location: Location,

    private tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private otherService: OtherService,

    private router: Router,

    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    //timePicker
    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    this.route.queryParams.subscribe((params) => {

      if (!params['id']) {

        this.router.navigateByUrl("/login");

      }

      else {

        this.mdlTempAccess.controls['strUnitID'].setValue(params['id'])

        this.getTempAccess()

      }

    })

  }

  getTempAccess = async () => {
    if (this.loading) return;
    this.loading = true;
    this.hasError = false;
    this.list_Result = [];
    this.pagedRows = [];
    try {
      const response = await axios.post('TemporaryAccess_List',
        this.otherService.stringNumberToNumber(this.mdlTempAccess.value));
      const result = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (!Array.isArray(result)) throw new Error('Invalid access list');
      this.list_Search = result;
      this.refreshTable(true);
    } catch {
      this.list_Search = [];
      this.hasError = true;
    } finally {
      this.loading = false;
    }
  }

  refreshTable(resetPage = false): void {
    const query = this.searchText.trim();
    this.list_Result = this.list_Search.filter((row: any) =>
      ['strFullName', 'strMobile', 'strSDate', 'strEDate']
        .some(key => String(row[key] ?? '').includes(query)));
    if (resetPage) this.currentPage = 1;
    const totalPages = Math.max(1, Math.ceil(this.list_Result.length / this.pageSize));
    this.currentPage = Math.min(this.currentPage, totalPages);
    const start = (this.currentPage - 1) * this.pageSize;
    this.pagedRows = this.list_Result.slice(start, start + this.pageSize);
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.refreshTable();
  }

  changePageSize(size: number): void {
    this.pageSize = size;
    this.refreshTable(true);
  }

  trackByAccess(_index: number, row: any): number {
    return row.iTemporaryAccess;
  }

  openModal(bEdit: boolean, item?: any) {

    this.mdlTempAccess.patchValue({

      strSDate: momentJalaali().format('jYYYY/jMM/jDD'),

      strSTime: momentJalaali().format('HH:mm'),

      strEDate: momentJalaali().format('jYYYY/jMM/jDD'),

      strETime: '23:59',

      strMobile: '',

      strPassword: '',

    })

    this.bEditMode = bEdit;

    if (this.bEditMode) {

      Object.keys(item).forEach((key: any) => {

        this.mdlTempAccess.get(key)?.setValue(item[key])

      })

    }

    $("#tempAccess-modal").modal("show");


  }

  new_TempAccess = async () => {

    const Stime = document.getElementById("Stime") as any;

    const Etime = document.getElementById("Etime") as any;

    const strSTime = moment(Stime.value.trim(), 'HH:mm').format('HH:mm');

    this.mdlTempAccess.get('strSTime')?.setValue(Stime.value);

    this.mdlTempAccess.get('strETime')?.setValue(Etime.value);

    if (this.mdlTempAccess.invalid) return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (moment(this.mdlTempAccess.get('strSDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(), 'day')) {

      return this.tooltip.showError('تاریخ شروع نمی تواند قبل از امروز باشد');

    }

    if (moment(this.mdlTempAccess.get('strEDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(), 'day')) {

      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از امروز باشد');

    }

    if (moment(this.mdlTempAccess.get('strEDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(this.mdlTempAccess.get('strSDate')?.value.trim(), 'jYYYY/jMM/jDD'))) {

      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از تاریخ شروع باشد');

    }

    if (moment(strSTime, 'HH:mm').isBefore(moment(moment().format('HH:mm'), 'HH:mm'))) {

      return this.tooltip.showError(`ساعت شروع نمی تواند گذشته باشد. (زمان فعلی : ${moment().format('HH:mm')})`);

    }

    if (this.mdlTempAccess.get('strMobile')?.value.length < 10) return this.tooltip.showError('لطفا شماره موبایل را به درستی وارد کنید');

    if (!this.bEditMode) {

      this.otherService.Showspinner();

      const resp = await axios.post(`TemporaryAccess_Save`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value));

      this.otherService.nonespinner();

      let res = JSON.parse(resp.data);

      if (res.iResult == 0) return this.tooltip.showError(res.strError);

      this.tooltip.showSuccess('با موفقیت ثبت شد');

      this.list_Search.push(res[0]);
      this.refreshTable();

      $("#tempAccess-modal").modal("hide");

    }

    else {

      $.confirm({

        title: `آیا از ویرایش دسترسی اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this.otherService.Showspinner()

              let res = JSON.parse((await axios.post(`TemporaryAccess_Edit`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value))).data.toString());

              this.otherService.nonespinner();

              if (res.iResult == 0) return this.tooltip.showError(res.strError);

              this.tooltip.showSuccess('با موفقیت ویرایش شد');

              const index = this.list_Search.findIndex((row: any) =>
                row.iTemporaryAccess == this.mdlTempAccess.get('iTemporaryAccess')?.value);
              if (index !== -1) this.list_Search[index] = res[0];
              this.refreshTable();

              $("#tempAccess-modal").modal("hide");

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  remove_TempAccess = async (item: any) => {

    $.confirm({

      title: `آیا از حذف این دسترسی اطمینان دارید؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iTemporaryAccess: item.iTemporaryAccess,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this.otherService.Showspinner();

            const resp = await axios.post(`TemporaryAccess_Delete`, this.otherService.stringNumberToNumber(model));

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.iResult == 0) return this.tooltip.showError(res.strError);

            this.list_Search = this.list_Search.filter((row: any) =>
              row.iTemporaryAccess !== item.iTemporaryAccess);
            this.refreshTable();

            return this.tooltip.showSuccess('دسترسی با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  openSmsModal(item: any) {

    Object.keys(item).forEach((key: any) => {

      this.mdlTempAccess.get(key)?.setValue(item[key])

    })

    $("#tempSMS-modal").modal("show");


  }

  send_SMS = async () => {

    const strMobile = this.mdlTempAccess.get('strMobile')?.value;

    if (this.mdlTempAccess.invalid) return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (strMobile.length < 11 || strMobile.length > 11) return this.tooltip.showError('لطفا شماره موبایل را به درستی وارد کنید');

    this.otherService.Showspinner();

    const resp = await axios.post(`TemporaryAccess_SMSURL`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.tooltip.showError(res.strError);

    this.tooltip.showSuccess('پیامک با موفقیت ارسال شد');

    $("#tempSMS-modal").modal("hide");


  }

}
